




































import {Component, Prop, Vue} from 'vue-property-decorator';
import {namespace} from 'vuex-class';
import {toI18n} from '@/utils/commonUtils';
const adminModule = namespace('admin');

@Component
export default class ServiceMasterRegisterCompletePage extends Vue {
  @Prop() private masterData: any;

  private getAdminId (): string {
    return this.masterData ? this.masterData.adminId : '';
  }
  private getAdminName (): string {
    return this.masterData ? this.masterData.adminName : '';
  }
  private getPhoneNo (): string {
    return this.masterData ? this.masterData.contactInfo.phoneNo : '';
  }
  private getMobileNo (): string {
    return this.masterData ? this.masterData.contactInfo.mobileNo : '';
  }
  private getExternalAccessEnabled (): boolean {
    return this.masterData ? this.masterData.externalAccessEnabled : false;
  }
  private getGuideMessage (): string {
    return this.toI18n('COMPLETE_GUIDE_MESSAGE_2').replace('{{email}}', this.masterData ? this.masterData.contactInfo.email : '');
  }

  created () {
    this.$emit('getAdminsTempService');
  }

  private toI18n (needToI18nStr: string, bCommon: boolean = false): string {
    return toI18n(this.$t((bCommon ? '' : 'SERVICE_REGISTER_') + needToI18nStr));
  }
}
